import { generatePath } from 'react-router-dom';
import { paths } from 'src/constants/variables';
import { NavigationElementData } from './NavigationElement';

export const NAVIGATION_ELEMENTS: NavigationElementData[] = [
    { link: paths.newOffer, name: 'NEUES ANGEBOT' },
    { link: paths.savedOffers, name: 'ANGEBOTE' },
    { link: generatePath(paths.products), name: 'PRODUKTE' },
];
